export default theme => ({
  resizableRow: {
    width: '100%',
    borderBottom: `1px solid ${theme.indigo3}`,
    position: 'absolute',
    zIndex: 2
  }
});
